<template>
  <v-main class="pa-4">
    <div class="d-flex">
      <h2 v-if="isEdit">編輯表單</h2>
      <h2 v-else>新增表單</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$router.back()" color="primary" depressed>上一頁</v-btn>
    </div>
    <v-divider class="my-4"></v-divider>
    <v-form ref="form" id="form">
      <section>
        <v-subheader class="pl-0">基本資料</v-subheader>
        <div>
          <v-text-field
          v-model="form.name"
          label="表單名稱"
          :rules="rules.name"
          outlined
          required
        ></v-text-field>
        </div>
      </section>
      <section>
        <v-subheader class="pl-0">日期與時間</v-subheader>
        <div>
          <div v-for="(item, i) in form.datetime" :key="i">
            <v-row>
              <v-col cols="4" class="d-flex">
                <div class="text-h6 ma-4">{{i + 1}}</div>
                <datepicker v-model="item.date"/>
              </v-col>
              <v-col cols="7" class="d-flex flex-column">
                <div v-for="(time, j) in item.times" :key="j" class="d-flex">
                  <v-text-field
                    v-model="time.name"
                    label="輸入時段選項"
                    :rules="rules.time"
                    prepend-icon="mdi-clock-outline"
                    class="mr-4"
                    outlined
                    required
                  ></v-text-field>
                   <v-select
                      v-model="time.candidates"
                      label="候選人數"
                      :items="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]"
                      class="mr-4"
                      outlined
                    ></v-select>
                  <v-btn @click="removeTimeSlot(item.times, j)" class="mt-2 align-self-start" color="primary" depressed small fab>
                    <v-icon dark>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
                <v-btn @click="addTimeSlot(item.times)" class="align-self-end" color="primary" depressed>新增時段選項</v-btn>
              </v-col>
              <v-col cols="1">
                <v-btn @click="removeDatetime(form.datetime, i)" class="mt-2" color="error" depressed>刪除</v-btn>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
          </div>
          <div class="d-flex justify-center">
            <v-btn @click="addDatetime" color="primary" large>新增日期與時間</v-btn>
          </div>
        </div>
      </section>
      <section>
        <v-subheader class="pl-0">主題</v-subheader>
        <div>
          <div v-for="(theme, i) in form.themes" :key="theme + i" class="d-flex">
            <span class="number text-h6 ma-3">{{i + 1}}</span>
            <v-text-field
              v-model="theme.name"
              label="主題選項名稱"
              :rules="rules.theme"
              outlined
              required
            ></v-text-field>
            <v-btn @click="removeTheme(form.themes, i)" class="ma-3" color="error" depressed>刪除</v-btn>
          </div>
          <div class="d-flex justify-center">
            <v-btn @click="addTheme" color="primary" large>新增主題選項</v-btn>
          </div>
        </div>
      </section>
      <section>
        <v-subheader class="pl-0">工具</v-subheader>
        <div>
          <div v-for="(tool, i) in form.tools" :key="tool + i" class="d-flex">
            <span class="number text-h6 ma-3">{{i + 1}}</span>
            <v-text-field
              v-model="tool.name"
              label="工具選項名稱"
              :rules="rules.tool"
              outlined
              required
            ></v-text-field>
            <v-btn @click="removeTool(form.tools, i)" class="ma-3" color="error" depressed>刪除</v-btn>
          </div>
          <div class="d-flex justify-center">
            <v-btn @click="addTool" color="primary" large>新增工具選項</v-btn>
          </div>
        </div>
      </section>
    </v-form>
    <v-divider class="my-4"></v-divider>
    <div class="d-flex ma-8">
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="primary" depressed>儲存</v-btn>
    </div>
  </v-main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Datepicker from '@/components/Datepicker.vue'
import { addForm, updateForm } from '@/firebase'
import { cloneDeep } from 'lodash'

const TIMESOLT_FORMAT = { name: '', candidates: 0 }
const DATETIME_FORMAT = { date: '', times: [TIMESOLT_FORMAT] }
const THEME_FORMAT = { name: '' }
const TOOL_FORMAT = { name: '' }

export default {
  name: 'FormEdit',
  data: () => ({
    isEdit: false,
    form: {
      name: '',
      datetime: [],
      themes: [],
      tools: [],
      candidatesCount: 0
    },
    rules: {
      name: [v => !!v || '請填寫表單名稱'],
      time: [v => !!v || '請填寫時段內容'],
      theme: [v => !!v || '請填寫主題選項名稱'],
      tool: [v => !!v || '請填寫工具選項名稱']
    }
  }),
  created () {
    this.isEdit = this.$route.meta.isEdit
    if (this.isEdit) {
      const form = this.getFormById(this.$route.params.formId)
      // 回去上一頁，把資料Load回local端
      if (!form) this.$router.push({ name: 'Forms' })
      this.form = Object.assign(this.form, form)
    } else {
      this.addDatetime()
      this.addTheme()
      this.addTool()
    }
  },
  methods: {
    ...mapMutations({
      showDialog: 'SHOW_DIALOG',
      startLoading: 'START_LOADING'
    }),
    addTimeSlot (times) {
      this.arrayAdd(times, TIMESOLT_FORMAT)
    },
    removeTimeSlot (times, i) {
      this.arrayRemove(times, i)
    },
    addDatetime () {
      this.arrayAdd(this.form.datetime, DATETIME_FORMAT)
    },
    removeDatetime (datetime, i) {
      this.arrayRemove(datetime, i)
    },
    addTheme () {
      this.arrayAdd(this.form.themes, THEME_FORMAT)
    },
    removeTheme (theme, i) {
      this.arrayRemove(theme, i)
    },
    addTool () {
      this.arrayAdd(this.form.tools, TOOL_FORMAT)
    },
    removeTool (tools, i) {
      this.arrayRemove(tools, i)
    },
    arrayAdd (array, item = '') {
      array.push(cloneDeep(item))
    },
    arrayRemove (array, i) {
      if (array.length === 1) {
        alert('只剩下一個了，不能刪啦!!')
        return
      }
      array = array.splice(i, 1)
    },
    async submit () {
      const isValid = this.$refs.form.validate()
      if (!isValid) return
      this.startLoading()
      try {
        const formId = this.$route.params.formId
        // const themes = this.form.themes.map(theme => { return { name: theme } })
        // const tools = this.form.tools.map(tool => { return { name: tool } })
        if (this.isEdit) {
          await updateForm(formId, { ...this.form })
        } else {
          await addForm(this.form)
        }
        this.showDialog({
          title: this.isEdit ? '更新成功！' : '新增成功'
        })

        this.$router.push({ name: 'Forms' })
      } catch (error) {
        this.showDialog({
          title: this.isEdit ? '更新失敗！' : '新增失敗',
          content: `錯誤訊息: ${error.message}`
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getFormById'])
  },
  components: {
    Datepicker
  }
}
</script>
<style lang="scss" scoped>
#form {
  max-width: 800px;
  margin: auto;

  .number {
    min-width: 30px;
  }
}
</style>
